<script>
    export let title_text = "";
    export let text = "";
    export let logo_url = "";
</script>
<div class="p-1 text-center">
    <img width="200" height="188" class="d-block mx-auto img-fluid" src="{logo_url}" alt="DFStud's cartoon horse mascot Studly"
        style="max-width: 200px;">
    <div class="col-lg-6 mx-auto p-2 glass">
        <h1 class="display-5 fw-bold">{title_text}</h1>
        <p class="lead">{@html text}</p>
    </div>
</div>